import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-answer-view',
  templateUrl: './answer-view.component.html',
  styleUrls: ['./answer-view.component.scss']
})
export class AnswerViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
